import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
import actions from './actions';
import state from './state';
import getters from './getters';
import mutations from './mutations';

export const serviceComputed = {
	...mapGetters('cpnyPopupStore', Object.keys(getters)),
	...mapState('cpnyPopupStore', Object.keys(state))
};
export const serviceMethods = {
	...mapActions('cpnyPopupStore', Object.keys(actions)),
	...mapMutations('cpnyPopupStore', Object.keys(mutations))
};
